import { createApiSlice } from "@common";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {HCM_EMPLOYEE_TEMPLATE_DOWNLOAD_DATA, HCM_EMPLOYEE_UPLOAD_DATA,CRUD_EMPLOYEE_MAIN_FETCH_BY_ID,CRUD_EMPLOYEE_BY_ORG_LEGAL_ID , CRUD_EMPLOYEE_MAIN, HCM_PERSONAL_DOWNLOAD_DATA , HCM_PERSONAL_UPLOAD_DATA } from "@routes";
import axios from "axios";
// Define the API config array
const apiConfig = [
  {
    name: "addEmployeeMain",
    method: "post",
    url: CRUD_EMPLOYEE_MAIN,
    stateKey: "message",
  },
  {
    name: "getEmployeeMain",
    method: "get",
    url: CRUD_EMPLOYEE_MAIN,
    stateKey: "data",
  },
  
   {
    name: "getEmployeeByOrgId",
    method: "get",
    url: CRUD_EMPLOYEE_BY_ORG_LEGAL_ID ,
    stateKey: "employeeData",
  },
  {
    name: "updateEmployeeMain",
    method: "put",
    url: CRUD_EMPLOYEE_MAIN,
    stateKey: "message",
  },
  {
    name: "deleteEmployeeMain",
    method: "delete",
    url: CRUD_EMPLOYEE_MAIN,
    stateKey: "message",
  },
  {
    name: "getEmployeeMainDetailsById",
    method: "get",
    url:CRUD_EMPLOYEE_MAIN_FETCH_BY_ID,
    stateKey: "details",
  },
  // {
  //   name: "uploadEmployeeMainFile",
  //   method: "post",
  //   url: HCM_PERSONAL_UPLOAD_DATA,
  //   stateKey: "message",
  // },
];
export const uploadEmployeeMainFile = createAsyncThunk(
  "prospect/uploadEmployeeMainFile",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await axios.post(HCM_EMPLOYEE_UPLOAD_DATA, formData, {
        withCredentials: true,
        responseType: "blob",
      });

      console.log(res)
      
      const contentType = res.headers["content-type"];

      // Backend returned failed Excel
      if (
        contentType?.includes(
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        )
      ) {
        const url = globalThis.URL.createObjectURL(
          new Blob([res.data])
        );

        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", "FailedEmployeeMains.xlsx");

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        globalThis.URL.revokeObjectURL(url);

        return {
          message: "Some employees failed. Failed records have been downloaded.",
        };
      }

      // Backend returned JSON response
      const text = await res.data.text();
      const data = JSON.parse(text);

      return data;
    } catch (err) {
      let errorData = err?.response?.data;

      // Error response can also be a Blob
      if (errorData instanceof Blob) {
        try {
          const text = await errorData.text();
          errorData = JSON.parse(text);
        } catch {
          // Keep original errorData if it is not JSON
        }
      }

      return rejectWithValue(errorData);
    }
  }
);
export const downloadEmployeeMainData = createAsyncThunk(
  "prospect/downloadEmployeeMainData",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      console.log("Downloading prospect data with params:", data);
      await axios
        .get(HCM_EMPLOYEE_TEMPLATE_DOWNLOAD_DATA , {
          params: data,
          withCredentials: true,
          responseType: "blob",
        })
        .then((res) => {
          const url = globalThis.URL.createObjectURL(new Blob([res.data]));

          const link = document.createElement("a");

          link.href = url;

          link.setAttribute("download", "EmployeeMains.xlsx");

          document.body.appendChild(link);

          link.click();
        });
    } catch (err) {
      return rejectWithValue(err.response);
    }
  }
);
// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    employeeData:{},
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    [downloadEmployeeMainData.pending]: (state) => {
      state.loading = true;
    },

    [downloadEmployeeMainData.fulfilled]: (state) => {
      state.loading = false;
    },

    [downloadEmployeeMainData.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [uploadEmployeeMainFile.pending]: (state) => {
      state.loading = true;
    },

    [uploadEmployeeMainFile.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },

    [uploadEmployeeMainFile.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage =
        action?.payload?.message ||
        action?.payload?.data?.message;
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "prospect",
  apiConfig,
  customReducers,
);
const prospectSlice = slice;

// Export the slice's reducer
export default prospectSlice.reducer;

// Export thunks
export const {
  addEmployeeMain,
  getEmployeeMain,
  updateEmployeeMain,
  deleteEmployeeMain,
  getEmployeeMainDetailsById,
  getEmployeeByOrgId
  // uploadEmployeeMainFile
} = thunks;

// Export actions
export const { rowSelect } = actions;
